<ng-container *ngIf="isDataLoaded">
  <app-service-limit-list [serviceLimitTable]="serviceLimitTable"></app-service-limit-list>
  <div class="mt-4"></div>
  <app-service-list [serviceTable]="serviceTable"></app-service-list>
</ng-container>
